import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading2 = () => {
    return (
        <div className='my-4'>
            <Spinner animation="border" variant="success" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
};

export default Loading2;